var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-card",
        {
          staticClass: "mt-3",
          attrs: {
            title:
              _vm
                .$t("apeironGwApp.buscadorInstitucionesSnp.card.institucion")
                .toString() +
              ": " +
              _vm.institucion.nombreInstitucion,
          },
        },
        [
          _c(
            "b-row",
            { staticClass: "my-1" },
            [
              _c("b-col", [
                _c("strong", [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm
                          .$t(
                            "apeironGwApp.buscadorInstitucionesSnp.card.reniecyt"
                          )
                          .toString() + ":"
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", {
                  domProps: { textContent: _vm._s(_vm.institucion.reniecyt) },
                }),
              ]),
              _vm._v(" "),
              _c("b-col", [
                _c("strong", [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm
                          .$t(
                            "apeironGwApp.buscadorInstitucionesSnp.card.claveInstitucion"
                          )
                          .toString() + ":"
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    textContent: _vm._s(_vm.institucion.claveInstitucion),
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c("strong", [
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(
                          _vm
                            .$t(
                              "apeironGwApp.buscadorInstitucionesSnp.card.estatus"
                            )
                            .toString() + ":"
                        ),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.institucion.activo
                    ? _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm
                              .$t(
                                "apeironGwApp.buscadorInstitucionesSnp.card.activo"
                              )
                              .toString()
                          ),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !!_vm.institucion.reniecyt && _vm.seleccionarSoloInstitucion
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover.top.left",
                              value: _vm.$t(
                                "apeironGwApp.buscadorInstitucionesSnp.mensajes.seleccionarInstitucion"
                              ),
                              expression:
                                "$t('apeironGwApp.buscadorInstitucionesSnp.mensajes.seleccionarInstitucion')",
                              modifiers: { hover: true, top: true, left: true },
                            },
                          ],
                          staticClass: "accion-label",
                          attrs: { variant: "outline" },
                          on: {
                            click: function ($event) {
                              return _vm.seleccionarSinSede()
                            },
                          },
                        },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "check-circle-fill",
                              variant: "success",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "my-1" },
            [
              _c("b-col", [
                _c("strong", [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm
                          .$t("apeironGwApp.buscadorInstitucionesSnp.card.pais")
                          .toString() + ":"
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", {
                  domProps: { textContent: _vm._s(_vm.institucion.pais) },
                }),
              ]),
              _vm._v(" "),
              _c("b-col", [
                _c("strong", [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm
                          .$t(
                            "apeironGwApp.buscadorInstitucionesSnp.card.entidadFederativa"
                          )
                          .toString() + ":"
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    textContent: _vm._s(_vm.institucion.entidadFederativa),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("b-col", [
                _c("strong", [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm
                          .$t(
                            "apeironGwApp.buscadorInstitucionesSnp.card.municipio"
                          )
                          .toString() + ":"
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", {
                  domProps: { textContent: _vm._s(_vm.institucion.municipio) },
                }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "my-1" },
            [
              _c("b-col", { attrs: { cols: "3" } }, [
                _c("strong", [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm
                          .$t(
                            "apeironGwApp.buscadorInstitucionesSnp.card.sector"
                          )
                          .toString() + ":"
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", {
                  domProps: { textContent: _vm._s(_vm.institucion.sector) },
                }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.ocultarSedes
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "my-2 mx-2 area-responsive area-responsive-tabla",
                    },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          bordered: "",
                          small: "",
                          "head-variant": "dark",
                          items: _vm.institucion.sedes,
                          fields: _vm.fieldsSedes,
                          "show-empty": "",
                          "empty-text": _vm.$t(
                            "apeironGwApp.buscadorInstitucionesSnp.mensajes.sinRegistros"
                          ),
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "cell(activo)",
                              fn: function (data) {
                                return [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          data.item.activo
                                            ? "apeironGwApp.buscadorInstitucionesSnp.card.activo"
                                            : "apeironGwApp.buscadorInstitucionesSnp.card.inactivo"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              },
                            },
                            {
                              key: "cell(acciones)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover.top",
                                          value: _vm.$t(
                                            "apeironGwApp.buscadorInstitucionesSnp.mensajes.seleccionar"
                                          ),
                                          expression:
                                            "$t('apeironGwApp.buscadorInstitucionesSnp.mensajes.seleccionar')",
                                          modifiers: { hover: true, top: true },
                                        },
                                      ],
                                      attrs: { variant: "outline" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.seleccionarConSede(
                                            data.item
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("b-icon", {
                                        attrs: {
                                          icon: "check-circle-fill",
                                          variant: "success",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1537663195
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.ocultarSedes
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.institucion.sedes.length,
                          "per-page": _vm.perPage,
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }